import { IObject } from '../types';
import {
  IStateStorageConfig,
  IStorageConfig,
  clearStorage,
  getStateFromStorage,
  getStorage,
  setStorage,
  setStorageFromState,
  namespace as storageNamespace,
} from './storageService';

export const namespace = storageNamespace;

export const storageAvailable = () => {
  try {
    if ('localStorage' in window && window.localStorage !== null) {
      const test = '__storage_test__';
      localStorage?.setItem(test, test);
      localStorage?.removeItem(test);
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const getLocalStorage = <T = IObject>(key: string): T => {
  if (storageAvailable()) {
    return getStorage(key, localStorage);
  }
  return null;
};

export const setLocalStorage = (key: string, data: Record<string, any>): void => {
  if (storageAvailable()) {
    setStorage(key, data, localStorage);
  }
};

export const clearLocalStorage = (key: string): void => {
  if (storageAvailable()) {
    clearStorage(key, localStorage);
  }
};

export type IAddLocalStorageListenerCallback = (event: StorageEvent) => void;
export type IRemoveLocalStorageListenerCallback = () => void;

export const addLocalStorageListener = (
  key: string,
  callback: IAddLocalStorageListenerCallback
): IRemoveLocalStorageListenerCallback => {
  const handleStorageEvent = (event: StorageEvent) => {
    if (event.key === `${namespace}.${key}`) {
      callback(event);
    }
  };

  window.addEventListener('storage', handleStorageEvent);

  return () => {
    window.removeEventListener('storage', handleStorageEvent);
  };
};

export const getStateFromLocalStorage = (
  storageConfig: IStorageConfig,
  storage: Storage = localStorage
) => {
  if (storageAvailable()) {
    return getStateFromStorage(storageConfig, storage);
  }
  return null;
};

export const setLocalStorageFromState = (state: any, stateConfig: IStateStorageConfig): void => {
  if (storageAvailable()) {
    setStorageFromState(state, stateConfig, localStorage);
  }
};
